
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/privacy-policy",
      function () {
        return require("private-next-pages/support/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/privacy-policy"])
      });
    }
  